import { jsx as _jsx } from "react/jsx-runtime";
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { select_ui_settings } from 'console/redux/settings-actions';
import { memo, useMemo } from 'react';
import { SensorCard } from '../../../../sensors/sensor-card';
import { SensorProvider } from '../../../../sensors/sensor-card/provider';
import * as S from '../../styles';
export const GuardZoneSensors = memo(function GuardZoneSensors(props) {
    const { sensors_config } = props;
    const guard_sensors = useMemo(() => sensors_config.map((sensor_config) => (_jsx(SensorProvider, { sensor_config: sensor_config, children: _jsx(SensorCard, {}) }, sensor_config.id))), [sensors_config]);
    const { tab_cards_size_multiplier = 1 } = useAppSelector(select_ui_settings);
    return (_jsx(S.GuardSensors, { multiplier: tab_cards_size_multiplier, children: guard_sensors }));
});
